import React from 'react';

import { BuilderBlocks } from '@builder.io/react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useNavElements } from '~/shared/utils/NavElements';
import { Sticky, HeaderAttachment } from '~/techstyle-shared/react-components';

const RefContainer = styled.div`
  width: 100%;
  z-index: 10;
`;

const StyledSticky = styled(Sticky)`
  width: 100%;
  .sticky-inner-wrapper {
    z-index: 1;
  }
`;

const StyledBuilderBlocks = styled(BuilderBlocks)`
  position: relative;
  z-index: 10; /* Adding z-index so the filters button animation doesn't overlap the sticky header */
  ${({ $backgroundColor }) =>
    $backgroundColor &&
    `
      background-color: ${$backgroundColor}
    `};

  ${({ theme }) => theme.builderHeader.stickyContainer.contents}
`;

const HeaderAttachmentContainer = styled(HeaderAttachment.Container)`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  flex-wrap: wrap;

  #Nav_MiniCart_Mobile {
    box-shadow: 0px 0px 28px -5px rgba(0, 0, 0, 0.15);
    border-radius: 6px;

    footer {
      box-shadow: unset;
    }
  }
`;

const BuilderStickyHeaderContainer = ({ builderBlock, backgroundColor }) => {
  const { headerAttachmentContainerRef, stickyBannerRef } = useNavElements();

  return (
    <RefContainer ref={headerAttachmentContainerRef}>
      <StyledSticky ref={stickyBannerRef}>
        <StyledBuilderBlocks
          blocks={builderBlock.children}
          parentElementId={builderBlock.id}
          $backgroundColor={backgroundColor}
        />
        <HeaderAttachmentContainer />
      </StyledSticky>
    </RefContainer>
  );
};

BuilderStickyHeaderContainer.propTypes = {
  backgroundColor: PropTypes.string,
  builderBlock: PropTypes.object,
};

export default BuilderStickyHeaderContainer;
